import * as React from 'react'
import cx from 'clsx'

import styles from './CardNew.module.scss'

type Props = {
	formTitle?: string
	className?: string
}

export const CardNew = ({
	children,
	className,
	formTitle = 'Заявка на кредит',
}: React.PropsWithChildren<Props>) => {
	return (
		<div className={cx(styles.card, className)}>
			<h2 className={styles.h2}>{formTitle}</h2>
			{children}
		</div>
	)
}
